module.exports = __webpack_public_path__ + "img/ic_person.18f0eb5c.svg";